import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../shared/LanguageService';
import ProductGroupForm from './ProductGroupForm';
import * as Actions from './Actions';
import notify from '../../shared/feedback/notifications';
import IProductType from './IProductGroup';
import { Button, Modal } from 'react-bootstrap';
import { assign } from '../../shared/Assign';
import * as ErrorTransformation from '../../shared/ErrorTransformation';

export class EditProductGroupModal extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            errors: {},
            showModal: false,
            productGroup: { name: '', products: [] },
            products: [],
            creating: false
        };

        this.editProductGroup = this.editProductGroup.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onProductChange = this.onProductChange.bind(this);
        this.formIsValid = this.formIsValid.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.actions
            .loadEditProductGroup(this.props.productGroupId)
            .then(() => {
                this.setState({
                    productGroup: assign({}, this.props.edit.productGroup),
                    products: assign([], this.props.edit.products)
                });
            })
            .catch((errorResponse: any) => {
                errorResponse.errors.forEach((e: any) => {
                    notify.failure(e.value);
                });
            });
    }

    onChange(e: any) {
        let productGroup = this.state.productGroup;
        productGroup[e.target.name] = e.target.value;
        this.setState({ productGroup: productGroup });
    }

    onProductChange(e: any) {
        let productGroup = this.state.productGroup;
        if (e.target.checked) {
            productGroup['products'].push(parseInt(e.target.value));
        } else {
            productGroup['products'] = productGroup['products'].filter(
                (p) => p !== parseInt(e.target.value)
            );
        }
        this.setState({ productGroup: productGroup });
    }

    formIsValid() {
        return this.state.productGroup.name && this.state.productGroup.name.length > 0;
    }

    editProductGroup(): void {
        this.setState({ creating: true });
        this.props.actions
            .updateProductGroup(this.state.productGroup)
            .then(() => {
                this.setState({
                    productGroup: { name: '', products: [] },
                    creating: false
                });
                this.props.closeModal();
                notify.success(Translate('product-groups/notification/product-group-updated'));
            })
            .catch((errorResponse: any) => {
                this.setState({
                    errors: ErrorTransformation.toNamedError(errorResponse),
                    creating: false
                });
            });
    }

    render() {
        return (
            <Modal show={this.props.shouldShowModal} onHide={this.props.closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {Translate('product-groups/modal/edit/type/edit-product-group')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ProductGroupForm
                        productGroup={this.state.productGroup}
                        products={this.state.products}
                        onChange={this.onChange}
                        onProductChange={this.onProductChange}
                        errors={this.state.errors}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.closeModal}>
                        {Translate('product-groups/modal/edit/footer/button-label/close')}
                    </Button>
                    <Button
                        disabled={!this.formIsValid() || this.state.creating}
                        bsStyle="primary"
                        onClick={this.editProductGroup}
                    >
                        {Translate('product-groups/modal/edit/footer/button-label/save')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        edit: state.productGroups.edit,
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            loadEditProductGroup: (id: number) => dispatch(Actions.loadEditProductGroup(id)),
            updateProductGroup: (productGroup: any) =>
                dispatch(Actions.updateProductGroup(productGroup))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditProductGroupModal);
